import React, { useEffect, useRef } from "react";
import { FiPlus } from "react-icons/fi";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Assets/review/tushar.png"
import db1 from "../Assets/review/db1.png";
import db from "../Assets/review/db.jpg";
import about from "../Assets/review/about.png";
import Footer from "../Layaouts/Footer";
const testimonials = [
  {
    name: "Tushar Ambaliya & Vidhi Sardhara",
    location: "USA",
    quote: "We are delighted to share our heartfelt thanks to the Gujarati NRI Matrimony platform for helping us connect. Through this wonderful website, our paths crossed, and what began as a simple introduction soon turned into a lifelong bond.We truly appreciate the efforts of the team and the community for creating a respectful and trusted space where families can meet like-minded partners with shared values and culture.",
    profileImage: require("../Assets/review/tushar.png"),
    testimonialImage: require("../Assets/review/tushar.png"),
  },
  {
    name: "Bharatkumar & Namrata Patel",
    location: "MI, USA",
    quote: "We are truly grateful to the Gujarati NRI Matrimony website for helping our son, Dr. Tejas Patel (USA), find his life partner, Dr. Dharti Bhuva.This platform provides an excellent, trustworthy, and culturally rooted service that connects Gujarati families across the globe. The website’s smooth process, verified profiles, and commitment to preserving our traditions make it one of the best matrimonial platforms for the Gujarati community.We highly recommend this website to all families looking for genuine and meaningful matches for their loved ones.",
    profileImage: require("../Assets/review/tejas.png"),
    testimonialImage: require("../Assets/review/tejas.png"),
  },
  {
    name: "Ghanshyambhai Patel",
    location: "Gujarat, India",
    quote: "We are delighted to share that our daughter, Dr. Kripa Patel (Family Medicine Resident, Minnesota, USA), recently got engaged to Kumar Manthan Kakadiya (Electrical Engineer).We sincerely thank the Gujarati NRI Matrimony website for providing such a wonderful platform that connects families who value our culture, traditions, and community roots. The website is well-organized, transparent, and truly dedicated to helping Gujarati NRIs find their ideal life partners.",
    profileImage: require("../Assets/review/kripa.png"),
    testimonialImage: require("../Assets/review/kripa.png"),
  },
  {
    name: "Dhruv Patel & Hitusha Kachhadiya",
    location: "US",
    quote: "We are thrilled to start this beautiful journey together and feel truly fortunate to have connected through this website.We are grateful to the admins for creating a service that supports NRIs and their families in finding the right partner with ease and trust.We encourage everyone to explore the site, upload their biodata, and connect with potential matches—it truly makes the search for a life partner simple and secure. ",
    profileImage: require("../Assets/review/dhruv.jpg"),
    testimonialImage: require("../Assets/review/dhruv.jpg"),
  },
  {

    name: "Parth Vaghani & Krishna Lathiya",
    location: "Edison, New Jersey",
    quote: "We are overjoyed to have found each other through this website and are excited to begin our journey together.The platform made it simple for us to explore matches, connect securely, and maintain our cultural values while finding the right partner.",
    profileImage: require("../Assets/review/parth.png"),
    testimonialImage: require("../Assets/review/parth.png"),
  },
  {
    name: "Maulik B. Modiya & Krishna S. Kakadia",
    location: "New Jersey",
    quote: "We feel incredibly grateful to have found each other through this wonderful platform. Destiny brought us together, but this community made it possible.With the blessings of our parents and elders, our engagement marks the beginning of a beautiful new chapter in our lives.This initiative is more than just a matrimonial service — it’s a heartfelt effort that unites families and preserves our traditions across the world. ",
    profileImage: require("../Assets/review/maulik.png"),
    testimonialImage: require("../Assets/review/maulik.png"),
  },

  {
    name: "Harshil & Heer",
    location: "US",
    quote: "We’re so happy to share that we found each other through the Gujarati NRI Matrimony Group! This platform truly made it easy for us to connect and discover a genuine bond built on shared values and understanding.Thank you for helping us start this beautiful journey together! ",
    profileImage: require("../Assets/review/harshil.png"),
    testimonialImage: require("../Assets/review/harshil.png"),
  },
  {
    name: "Rajendra & Jagruti Tarpara",
    location: "Gujarat,India",
    quote: "We are extremely happy and grateful to Gujarati NRI Matrimony for helping us find the perfect match for our son, Bhargav Tarpara (H1B – IT, New Jersey), who recently got engaged to Kumari Krutisha (CA, M.S. Finance – Mumbai).The platform made the entire process simple, trustworthy, and culturally aligned. It beautifully connects families across countries while keeping our Gujarati values at heart.We truly appreciate the efforts of the Gujarati NRI Matrimony team for creating such a wonderful space where families can meet genuine, well-matched life partners.",
    profileImage: require("../Assets/review/bhargav.png"),
    testimonialImage: require("../Assets/review/bhargav.png"),
  },
];

const faqData = [
  {
    question: "What is Gujarati NRI Matrimony?",
    answer:
      "Gujarati NRI Matrimony is a dedicated platform for Gujaratis worldwide to find their ideal life partners while respecting cultural values and traditions.",
  },
  {
    question: "Who can join Gujarati NRI Matrimony?",
    answer:
      "Anyone of Gujarati origin, residing anywhere in the world, who is looking for a meaningful relationship can join.",
  },
  {
    question: "How do I create a profile?",
    answer:
      "Creating a profile is simple. Just sign up, fill in your details, and start searching for matches.",
  },
  {
    question: "Is my information safe and private?",
    answer:
      "Yes, we prioritize user privacy and security. Your data is kept confidential and is only shared as per your preferences.",
  },
  {
    question: "Are all profiles verified?",
    answer:
      "Yes, we have a profile verification process to ensure authenticity and safety.",
  },
];
const currentYear = new Date().getFullYear();

const Index = () => {

  const [openIndex, setOpenIndex] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const [activeIndex, setActiveIndex] = useState(3);
  const sliderRef = useRef(null);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Default value for smaller screens
    slidesToScroll: 1,
    centerMode: true,
    autoplay: true,
    centerPadding: "80px",
    focusOnSelect: true,
    initialSlide: 3,
    afterChange: (index) => setActiveIndex(index),
    responsive: [
      {
        breakpoint: 530, // Adjust for medium screens
        settings: {
          slidesToShow: 3,
          centerPadding: "10px",
        },
      },
    ],
  };

  return (
    <div>
      <nav
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? "bg-[#151515] shadow-md" : "bg-transparent"
          }`}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between p-4">
          <img src="/images/logo.png" alt="Logo" className="h-10" />
          <div className="flex gap-2 sm:gap-4">
            <NavLink
              to="/signup"
              className="p-2 sm:px-4 text-sm sm:text-lg sm:py-2 bg-[#E72848] border border-[#E72848] text-white rounded-lg shadow-md hover:bg-[#E72848]/80 transition"
            >
              Register Free
            </NavLink>
            <NavLink
              to="/signin"
              className="p-2 sm:px-4 sm:py-2 text-sm sm:text-lg text-white hover:text-[#151515] border border-[#fff] rounded-lg shadow-md hover:bg-white transition"
            >
              Log In
            </NavLink>
          </div>
        </div>
      </nav>

      <div className="relative">
        <div className="absolute flex gap-5 justify-center items-center bottom-0 w-full py-4 px-4 sm:px-0">
          <img src="/images/hero-1.png" alt="hero 1" className="hidden sm:block" />
          <div className="max-w-3xl text-center flex flex-col">
            <span className="text-white text-[30px] sm:text-[35px] md:text-[55px] font-semibold md:leading-[65px]">
              Find Your Cultural Value Perfect Partner From USA NRI
            </span>
            <span className="text-white my-2">
              Connecting Gujarati NRIs Across the Globe to Celebrate Love and
              Tradition
            </span>
            <span className="text-white  text-[20px] mb-[20px] font-[500]">
              We are non profit organisation
            </span>
          </div>
          <img src="/images/hero-2.png" alt="hero 2" className="hidden sm:block" />
        </div>
        <img
          src="/images/LandingPage.jpeg"
          alt="landing img"
          className="w-full min-h-[70vh] sm:min-h-[60vh] md:min-h-[60vh] lg:min-h-[60vh] object-cover"
        />
      </div>

      {/* Safe & Secure Network Section */}
      <div className="bg-white py-16 px-4">
        <div className="max-w-3xl mx-auto text-center">

          {/* Heart icon */}
          <div className="flex justify-center mb-8">
            <div className="w-[90px] h-[90px] bg-[#E72848] rounded-full flex items-center justify-center shadow-lg">
              <svg className="w-[42px] h-[42px] text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
              </svg>
            </div>
          </div>

         
          {/* Divider */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="h-px w-16 bg-[#E72848]/30"></div>
            <div className="w-2 h-2 rounded-full bg-[#E72848]"></div>
            <div className="h-px w-16 bg-[#E72848]/30"></div>
          </div>

          {/* Main text */}
          <p className="text-[20px] sm:text-[22px] text-[#444444] leading-[1.9] mb-10 max-w-2xl mx-auto">
            A <span className="text-[#E72848] font-semibold">safe, secure & private</span> network built to preserve our{" "}
            <span className="font-semibold text-[#151515]">NRI Gujarati heritage</span> and foster serious relationships between like-minded{" "}
            <span className="font-semibold text-[#151515]">NRI USA & global NRI Gujaratis</span> — to find your cultural value heritage partners for a{" "}
            <span className="text-[#E72848] font-semibold">safe and peaceful life.</span>
          </p>

          <NavLink to="/signup" className="bg-[#E72848] text-white px-[48px] py-[18px] rounded-full text-lg font-semibold hover:bg-[#E72848]/90 transition shadow-md">
            REGISTER FREE
          </NavLink>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto px-4 md:px-16">
        <div className="flex justify-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 justify-center items-center my-10">
            <div className="flex justify-center">
              <img src="/images/image-1.png" alt="demo" className="h-15 w-15" />
            </div>
            <div className="flex justify-center">
              <img src="/images/image-2.png" alt="demo" className="h-15 w-15" />
            </div>
            <div className="flex justify-center">
              <img src="/images/image-3.png" alt="demo" className="h-15 w-15" />
            </div>
            <div className="flex justify-center">
              <img src="/images/image-4.png" alt="demo" className="h-15 w-15" />
            </div>
          </div>
        </div>
      </div>

      <div className="relative">
        <img
          src="/images/Art-1.png"
          alt="demo"
          className="absolute bottom-20 left-0 h-[230px] z-0"
        />
        <img
          src="/images/Art-2.png"
          alt="demo"
          className="absolute bottom-0 right-0 z-0"
        />
        <div class="max-w-screen-xl mx-auto px-4 md:px-16 py-20 ">
          <div className="flex justify-center ">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5 place-items-center">
              {/* First row - 4 images */}
              <div className="relative z-5 ">
                <img src="/gujarati/p5.png" alt="demo" className="w-[272px] h-[200px] sm:h-[272px]   rounded-[10px] object-cover " />
                <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent absolute bottom-0 left-0 text-white font-[500] text-sm md:text-xl text-center w-full ">
                  <div className="pb-1"> Farmer</div>
                </div>
              </div>
              <div className="relative z-5">
                <img src="/gujarati/marchant.jpg" alt="demo" className="w-[272px] h-[200px] sm:h-[272px]   rounded-[10px] object-cover" />
                <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent absolute bottom-0  left-0 text-white font-[500] text-sm md:text-xl text-center w-full ">
                  <div className="pb-1">
                    Merchant
                  </div>
                </div>
              </div>
              <div className="relative z-5">
                <img src="/gujarati/p4.png" alt="demo" className="w-[272px] h-[200px] sm:h-[272px]   rounded-[10px] object-cover " />
                <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent absolute bottom-0  left-0 text-white font-[500]text-sm md:text-xl text-center w-full ">
                  <div className="pb-1"> IT engineers</div>
                </div>
              </div>
              <div className="relative z-5">
                <img src="/gujarati/p3.png" alt="demo" className="w-[272px] h-[200px] sm:h-[272px]   rounded-[10px] object-cover" />
                <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent absolute bottom-0  left-0 text-white font-[500]text-sm md:text-xl text-center w-full">
                  <div className="pb-1">Doctors</div>
                </div>
              </div>
              <div className="hidden lg:block"></div>
              <div className="relative z-5">
                <img src="/gujarati/p6.png" alt="demo" className="w-[272px] h-[200px] sm:h-[272px]   rounded-[10px] object-cover" />
                <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent absolute bottom-0  left-0 text-white font-[500] text-sm md:text-xl text-center w-full">
                  <div className="pb-1">Scientists</div>
                </div>
              </div>
              <div className="relative z-5">
                <img src="/gujarati/p2.png" alt="demo" className="w-[272px] h-[200px] sm:h-[272px]   rounded-[10px] object-cover" />
                <div className="bg-gradient-to-t from-black/70 via-black/40 to-transparent absolute bottom-0  left-0 text-white font-[500] text-sm md:text-xl text-center w-full">
                  <div className="pb-1">Politicians</div>
                </div>
              </div>
              <div className="hidden md:block"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative">
        <img
          src="/images/Art-3.png"
          alt="art"
          className="absolute bottom-13 left-0 z-0"
        />
        <img
          src="/images/Art-4.png"
          alt="art"
          className="absolute bottom-13 right-0 z-0"
        />
        <div className="bg-[#FEF7F8] py-20">
          <div class="max-w-screen-xl mx-auto px-4 md:px-16 ">
            <div className="flex justify-center">
              <div className="text-center font-bold text-3xl md:text-4xl lg:text-4xl">
                Find The <span className="text-[#E72848]">One For You</span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-7 sm:gap-5  my-10 ">
              <div className="flex flex-col sm:items-start w-full  items-center ">
                <div className="mb-3">
                  <img src="/images/Registration.png" alt="registration" className="h-[45px]" />
                </div>
                <div className="font-semibold">Registration</div>
                <div className="my-2 border-2 border-t border-[#E72848] w-[80px]"></div>
                <div className="text-center sm:text-left w-[250px] md:w-auto">Create your profile in just a few minutes.</div>
              </div>
              <div className="flex flex-col sm:items-start w-full  items-center">
                <div className="mb-3">
                  <img src="/images/Discover.png" alt="discover" className="h-[45px]" />
                </div>
                <div className="font-semibold">Discover</div>
                <div className="my-2 border-2 border-t border-[#E72848] w-[80px]"></div>
                <div className="text-center sm:text-left w-[250px] md:w-auto">
                  Browse through verified profiles tailored to your preferences.
                </div>
              </div>
              <div className="flex flex-col sm:items-start w-full  items-center">
                <div className="mb-3">
                  <img src="/images/Connect.png" alt="connect" className="h-[45px]" />
                </div>
                <div>Connect</div>
                <div className="my-2 border-2 border-t border-[#E72848] w-[80px]"></div>
                <div className="text-center sm:text-left w-[250px] md:w-auto">Select & Connect with Matches you like</div>
              </div>
              <div className="flex flex-col sm:items-start w-full  items-center">
                <div className="mb-3">
                  <img
                    src="/images/Your Perfect Match.png"
                    alt="demo"
                    className="h-[45px]"
                  />
                </div>
                <div>Your Perfect Match</div>
                <div className="my-2 border-2 border-t border-[#E72848] w-[80px]"></div>
                <div className="text-center sm:text-left w-[250px] md:w-auto">Celebrate your journey toward a lifelong partnership!</div>
              </div>
            </div>
            <div className="flex justify-center">
              <NavLink to='/signin' className="px-5 py-2 rounded-lg border border-[#E72848] font-bold bg-[#E72848] text-white cursor-pointer">
                Start Your Journey
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="py-16 md:py-20">
          {/* Title Section */}
          <div className="flex flex-col text-center justify-center">
            <div className="font-bold text-2xl md:text-4xl lg:text-5xl">
              What Our Users Say
            </div>
            <div className="font-bold text-2xl md:text-4xl lg:text-5xl">
              Real Stories of{" "}
              <span className="text-[#E72848]">Love and Connection</span>
            </div>
          </div>

          {/* Testimonial Section */}
          <div className="my-10 md:my-14 relative">
            <img
              src="/images/quote.png"
              alt="quote"
              className="absolute top-[-20px] md:top-[-30px] left-6 md:left-10 w-[50px] md:w-[70px]"
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 items-center bg-[#F9F9F9] p-6  rounded-2xl shadow-lg">
              {/* Testimonial Text */}
              <div className="flex flex-col gap-2 md:col-span-2 mt-2">
                <p className="text-sm md:text-base ">
                  {testimonials[activeIndex].quote}
                </p>

                <div className="font-semibold text-sm md:text-base">
                  – {testimonials[activeIndex].name},{" "}
                  {testimonials[activeIndex].location}
                </div>
              </div>

              {/* User Image */}
              <div className="flex justify-center md:justify-end">
                <img src={testimonials[activeIndex].testimonialImage} alt="demo" className="object-cover w-[370px] h-[270px] rounded-[10px]" />
              </div>
            </div>
            <div className="w-full max-w-[500px]  sm:w-[420px] mx-auto flex justify-center items-center mt-6 px-10 sm:px-6 md:px-0">
              <button
                className="prev-btn bg-white px-3 py-1 rounded-full border-2 border-black"
                onClick={() => sliderRef.current.slickPrev()}
              >
                ❮
              </button>

              <Slider
                ref={sliderRef}
                {...settings}
                className="w-full px-0"
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="p-2 !flex justify-center" onClick={() => setActiveIndex(index)} >
                    <img
                      src={testimonial.profileImage}
                      alt="profile"
                      className={`object-center w-12 h-12 sm:w-14 sm:h-14 object-cover rounded-full border-2 cursor-pointer transition-all duration-100 ${activeIndex === index
                        ? "p-[2px] border-red-500 scale-125"
                        : "border-gray-300 opacity-80"
                        }`}
                    />
                  </div>
                ))}
              </Slider>

              <button
                className="next-btn bg-white  px-3 py-1 rounded-full border-2 border-black"
                onClick={() => sliderRef.current.slickNext()}
              >
                ❯
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="relative pb-16">
        <img
          src="/images/Art-5.png"
          alt="art"
          className="absolute top-[50%] left-[5%] xl:left-[20%] z-0 h-[220px] hidden lg:block"
        />
        <div className="max-w-screen-xl mx-auto px-4 md:px-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <div className="flex gap-3">
                <div className="border-l-4 border-[#E72848]"></div>
                <div>
                  <div className="text-[#E72848] text-lg md:text-xl">FAQ</div>
                  <div className="font-semibold text-3xl md:text-3xl mt-2 max-w-[240px]">
                    Frequently Asked Questions
                  </div>
                </div>
              </div>
              <div className="text-[#777777] py-5">
                Here are some common questions our users ask about Gujarati NRI
                Matrimony. If you have additional queries, feel free to contact
                our support team.
              </div>
            </div>
            <div className="md:col-span-2">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className="border border-[#0000001A] shadow-[0px_4px_20px_0px_#0000000F] rounded-lg mt-5 p-5 flex flex-col gap-3 "
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="flex justify-between gap-1  text-left  items-center w-full cursor-pointer font-medium text-gray-700"
                  >
                    <div className="">{item.question}</div>
                    <div
                      className={`${openIndex === index ? 'rotate-45' : 'rotate-0'
                        } transition duration-500 ease-in-out`}
                    >
                      <FiPlus />
                    </div>
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out text-gray-600 ${openIndex === index ? 'max-h-max  opacity-100' : 'max-h-0 py-0 opacity-0'
                      }`}
                  >
                    {item.answer}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Index;
